<template>
    <div>
        <div class="text-left pre-footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="col-md-2">
                            <h3>科技元宇宙</h3>
                            <a href="/work/detail?type=about">关于我们</a>
                            <br />
                            <a href="/work/detail?type=info">大事记</a>
                        </div>
                        <div class="col-md-3">
                            <h3>法律协议</h3>
                            <a href="javascript:void(0);">服务条款</a>
                            <br />
                            <a href="javascript:void(0);">隐私政策</a>
                            <br />
                            <a href="javascript:void(0);">更多协议</a>
                        </div>
                        <div class="col-md-4">
                            <h3>联系我们:</h3>
                            <a href="javascript:void(0);">联系方式：010-62888049</a>
                            <br />
                            <a href="javascript:void(0);">联系电话：13269490809</a>
                            <br />
                            <a href="javascript:void(0);">邮编：100094</a>
                            <br />
                            <a href="javascript:void(0);">地址：北京市海淀区中关村壹号A3座701室</a>
                        </div>
                        <div class="col-md-3 text-center">
                            <img src="/work/static/img/code/code.jpg" alt="二维码" width="60%" style="margin-top:15px;" />
                            <p class="hh-text">商务合作</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <nav id="footer">
            <div class="container">
                <div class="pull-left fnav">
                    <p>
                        Copyright️2022 精航伟泰是精航伟泰测控仪器（北京）有限公司版权所有|
                        <a href="https://beian.miit.gov.cn/" style="color: #fff;" target="_blank">京ICP备11012690号-4</a>
                    </p>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'h-footer',
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {
        goLogin() {
            this.$router.push(`/work/login?backUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`);
        }
    }
};
</script>
<style scoped lang="scss">
@import 'index';
</style>
